const MAX_PENALTIES = 4;

export { MAX_PENALTIES };
